

















import { computed, defineComponent } from '@nuxtjs/composition-api';
import { MIN_DESKTOP_WIDTH } from '~/constants/ui';
import { SCHEMA_ITEM_PROP } from '~/constants/seo';
import { getUrlWithResizeQuery } from '~/helpers/twicpics/getUrlWithResizeQuery';
import { LOADING_MODE } from '~/constants/images';

export default defineComponent({
  name: 'TwicpicsPicture',
  components: {

  },
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: MIN_DESKTOP_WIDTH,
    },
    desktopHeight: {
      type: Number,
      required: true,
    },
    mobileHeight: {
      type: Number,
      required: true,
    },
    mode: {
      type: String,
      default: 'contain',
    },
    preload: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const desktopUrl = computed(() => getUrlWithResizeQuery(props.src, {
      mode: props.mode,
      width: props.width,
      height: props.desktopHeight,
    }));
    const mobileUrl = computed(() => getUrlWithResizeQuery(props.src, {
      mode: props.mode,
      width: props.width,
      height: props.mobileHeight,
    }));

    const loadingMode = computed(() => props.preload ? LOADING_MODE.EAGER : LOADING_MODE.LAZY);

    return {
      desktopUrl,
      mobileUrl,
      MIN_DESKTOP_WIDTH,
      SCHEMA_ITEM_PROP,
      loadingMode,
    };
  },
  head() {
    if (!this.preload) return;

    const links = [{
      rel: 'preload',
      as: 'image',
      href: this.desktopUrl,
      media: `(min-width: ${MIN_DESKTOP_WIDTH}px)`,
      fetchpriority: 'high',
    }, {
      rel: 'preload',
      as: 'image',
      href: this.mobileUrl,
      media: `(max-width: ${MIN_DESKTOP_WIDTH - 1}px)`,
      fetchpriority: 'high',
    }];

    return {
      link: links,
    };
  },
});

